import React, { Fragment } from 'react'
import { Button } from '@drifthq/tide-core'
import extensionIcon from 'images/extension.svg'
import newExtensionIcon from 'images/newExtensionIcon.png'

import './style.css'

export const ExtensionStep = ({ onInstallClick, installed, onSkipClick, onCompleteClick }) => {
  return (
    <Fragment>
      <h1>Take Drift Everywhere</h1>
      <p>Get the power of Drift in Gmail</p>
      <img alt="" className="logo chrome-logo" src={extensionIcon} />
      <p>Book meetings, enroll leads in sequences and keep a pulse on your VIP prospects - all from where you already spend most of your day.</p>
      <Button onClick={() => installed ? onCompleteClick() : onInstallClick()}>
        {installed ? 'Continue to your Dashboard' : 'Install the Drift Chrome Extension'}
        </Button>
      <a className="skip-for-now" onClick={onSkipClick} >Skip and Finish Setup</a>
    </Fragment>
  )
}

export const AEExtensionStep = ({ onInstallClick, installed, onSkipClick, onCompleteClick }) => {
  return (
    <Fragment>
      <h1>Nice! Now get notified so you never miss a target account</h1>
      <img alt="" className="logo new-chrome-logo" src={newExtensionIcon} />
      <p>Get notified immediately when target accounts are on your site so you can follow up with a quick chat or book a meeting with them via email.</p>
      <Button size="large" onClick={() => installed ? onCompleteClick() : onInstallClick()}>
        {installed ? 'Continue' : 'Get the Drift Chrome Extension'}
      </Button>
      <a className="skip-for-now" onClick={onSkipClick} >Skip</a>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/ExtensionStep/component.js